import gql from 'graphql-tag';

export const deleteFileMutation = gql`
  mutation deleteFile($id: Float!) {
    deleteFile(id: $id)
  }
`;
